import { render } from "./PageTopImage.vue?vue&type=template&id=479643b4&scoped=true"
import script from "./PageTopImage.vue?vue&type=script&lang=js"
export * from "./PageTopImage.vue?vue&type=script&lang=js"

import "./PageTopImage.vue?vue&type=style&index=0&id=479643b4&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-479643b4"

export default script